<template>
  <div id="app" :class="{ 'stand-alone': true }">
    <header class="portal-header sticky-top">
      <div class="portal-header__banner alert alert-primary" :class="clsDisplayBanner" role="alert">
        <span class="banner-text" v-html="bannerText"></span>
        <button class="close-banner btn-reset btn-dark bold-me" @click="toggleBanner">X</button>
      </div>

      <nav id="portal-nav" class="app-main navbar navbar-expand-lg navbar-light">
        <a class="brand-home navbar-brand mr-0" :href="wpData.site_url">ESA GNSS Science Support Centre</a
        ><span class="brand-line navbar-brand mr-0">&nbsp;|&nbsp;</span>
        <a class="brand-portal navbar-brand mr-0" :href="wpData.site_url + '/portal/'">GSSC Now</a>
        <span class="beta-message nav-item mb-3 ml-1">[BETA - SciKubeDat]</span>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li class="app-gssc-home-link nav-item">
              <a class="nav-link home-link" :href="wpData.site_url">GSSC</a>
            </li>
            <li
              class="app-main__item nav-item"
              :class="{ active: activeRoute(nav.path) }"
              v-for="(nav, idx) in navLinksLeft"
              :key="'l' + idx"
              v-show="nav.show"
            >
              <router-link :key="idx" class="nav-link" :class="nav.cl" :to="nav.path">{{ nav.name }}</router-link>
            </li>

            <!-- Labs dropdown -->
            <li
              class="app-main__item nav-item dropdown"
              :class="{
                active: activeRoute('/datalabs') || activeRoute('/lab/'),
              }"
            >
              <!-- <a
                href="https://www.google.com"
                class="nav-link"
                :class="{
                  active: activeRoute('/datalabs') || activeRoute('/lab/'),
                }"
                id="labs-dropdown"
                role="a"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                @click="updateRunningLabs"
              >Datalabs</a>-->
              <router-link
                class="nav-link"
                id="labs-dropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                to="/datalabs"
                @mouseenter.native="updateRunningLabs()"
                >Datalabs</router-link
              >

              <div v-if="someLabRunning" class="labs-menu dropdown-menu">
                <li
                  class="app-lab__item dropdown-item"
                  :class="{ active: activeRoute('/lab/' + lab.id) }"
                  v-for="lab in labLinks"
                  :key="lab.id"
                  v-if="lab.show"
                >
                  <router-link
                    class="nav-link"
                    :class="{ 'my-disabled': lab.status !== 'Running' }"
                    :to="{
                      name: 'lab',
                      params: { id: lab.id, labUrl: lab.url },
                    }"
                    ><i v-if="lab.status === 'Paused'" title="Paused" class="font-16 mr-1 icon-sleep-line"></i
                    ><i v-else-if="lab.status === 'Running'" title="Running" class="font-16 mr-1 icon-running"></i>
                    <i
                      v-else-if="lab.status === 'Initializing'"
                      title="Initializing"
                      class="font-16 mr-1 icon-progress"
                    ></i
                    >{{ lab.name }}</router-link
                  >
                </li>
                <li v-if="labLinks.length > 5" class="app-mylabs__item dropdown-item">
                  <router-link class="nav-link app-main__labs" to="/datalabs">More ...</router-link>
                </li>
              </div>
            </li>
            <!-- End Labs dropdown -->
            <li
              class="app-main__item nav-item"
              :class="{ active: activeRoute(nav.path) }"
              v-for="(nav, idx) in navLinksRight"
              :key="'r' + idx"
              v-show="nav.show"
            >
              <router-link :key="idx" class="nav-link" :class="nav.cl" :to="nav.path">{{ nav.name }}</router-link>
            </li>
            <!-- Admin menu item -->
            <!-- <li
              class="app-main__item nav-item"
              :class="{ active: activeRoute('/admin') }"
              v-show="auth && isUser && isAdmin"
            >
              <router-link class="nav-link app-main__admin" to="/admin">Admin</router-link>
            </li>-->

            <!-- FOR TESTING ONLY -->
            <!-- <li v-if="development" class="app-main__item dropdown nav-item">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Test Menu [{{ userType }}]
            </a>
            <div class="dropdown-menu">
              <ul v-if="development" class="dev-only">
                <li class="dropdown-item custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch1"
                    @click="testLoggedIn = !testLoggedIn"
                    v-model="testLoggedIn"
                  />
                  <label class="custom-control-label" for="customSwitch1"
                    >Logged In</label
                  >
                </li>
                <li class="dropdown-item custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch2"
                    @click="switchUser"
                    v-model="badUser"
                  />
                  <label class="custom-control-label" for="customSwitch2"
                    >expired token</label
                  >
                </li>
                <li class="dropdown-item custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitch3"
                    v-model="noHeaders"
                  />
                  <label class="custom-control-label" for="customSwitch3"
                    >No Session Headers</label
                  >
                </li>
              </ul>
            </div>
            </li>-->
            <!-- FOR TESTING ONLY -->
            <!-- <span class="nav-link font-weight-bold text-danger" href="#"
          >[Beta testers pre-release]</span
            >-->

            <!-- User dropdown menu -->
            <li
              class="app-main__item nav-item dropdown"
              :class="{
                active: activeRoute('/admin') || activeRoute('/help'),
              }"
            >
              <a
                class="nav-link"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <!-- @click.prevent="openProfileModalIfNotMobile"
                >-->
                <span v-if="auth" class="user-name">
                  {{ user }}
                  <i class="icon-astronaut"></i>
                </span>
                <span v-else class="user-name">
                  Anonymous
                  <i class="icon-alien"></i>
                </span>
              </a>
              <div class="logout-menu dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <li v-if="!auth" class="app-main__item dropdown-item">
                  <a class="app-main__signin nav-link" :href="loginUrl">Sign In</a>
                </li>
                <li v-if="!auth && development" class="app-main__item dropdown-item">
                  <a class="app-main__signin nav-link" href="#" @click.prevent="openLoginModal">Sign In (Dev)</a>
                </li>
                <li v-if="!auth" class="app-main__item dropdown-item">
                  <!-- <router-link class="app-main__register nav-link" tag="a" to="register">Sign Up</router-link> -->
                  <a class="app-main__register nav-link" :href="registerUrl">Sign Up</a>
                </li>
                <li
                  class="app-main__item dropdown-item"
                  :class="{ active: activeRoute('/admin') }"
                  v-show="auth && isUser && isAdmin"
                >
                  <router-link class="nav-link app-main__admin" to="/admin">Admin</router-link>
                </li>
                <li v-if="auth" class="app-main__item dropdown-item">
                  <a class="app-main__profile nav-link" href="#" @click.prevent="openProfileModal">Profile</a>
                </li>
                <li class="app-main__item dropdown-item" :class="{ active: activeRoute('/help') }">
                  <router-link class="app-main__help nav-link" tag="a" to="help">Help</router-link>
                  <!-- <a
                      class="app-main__help nav-link"
                      href="https://socci.esa.int/www/gssc_iapplications/Quick_Start_Guide.html"
                      target="_blank"
                  >Help</a>-->
                </li>
                <li class="app-main__item dropdown-item">
                  <a class="app-main__about nav-link" href="#" @click.prevent="openAboutModal">About</a>
                </li>
                <li v-if="auth" class="app-main__item dropdown-item">
                  <a role="button" class="app-main_logout nav-link" @click="onLogout">
                    <i class="icon-power_settings_new"></i>
                    <!-- <i class="icon align-middle menu-icon icon-power_settings_new p-0 d-inline-block mt-n1"></i> -->
                    Sign Out
                  </a>
                </li>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    <div class="container-fluid">
      <router-view
        v-if="showRouterView"
        :wpData="wpData"
        :user="user"
        @finishLoading="showLoader = false"
        @showLoader="showLoader = true"
        :key="forceReload"
        @login="launchLogin"
      />
    </div>
    <div v-if="showLoader" class="loader-wrapper">
      <div class="loader-back"></div>
      <div class="main-loader">
        <img :src="wpData.image_path + 'loading-earth.png'" class="earth-image" />
        <img :src="wpData.image_path + 'loading-sat.png'" class="satellite-image rotate" />
      </div>
    </div>
    <!-- avoid footer to come up while loading data -->
    <!-- <div v-if="showLoader" class="placeholder-empty"></div> -->

    <!-- About modal -->
    <about-modal class="app-main__about-modal" />
    <!-- Profile modal -->
    <profile-modal :quota="quota" class="app-main__profile-modal" @closeModal="profileClosed" />
    <!-- Login modal -->
    <login-modal @login="loginRequested" class="app-main__login-modal"></login-modal>
    <!-- Message modal -->
    <message-modal class="app-main__message-modal" :title="modalTitle" :message="modalMessage" :cancel="false" />
  </div>
</template>

<script>
import Vue from 'vue'
import * as api from '@/lib/api'
import AboutModal from '@/components/AboutModal.vue'
import ProfileModal from '@/components/ProfileModal.vue'
import LoginModal from '@/components/LoginModal.vue'
import MessageModal from '@/components/MessageModal.vue'
import { clickStrategies } from '@bosket/core'

export default {
  name: 'app',
  components: {
    AboutModal,
    ProfileModal,
    LoginModal,
    MessageModal,
  },
  data() {
    return {
      showLoader: this.$route.name != 'register' && this.$route.name != 'help',
      showRouterView: false,
      labLinks: [],
      someLabRunning: false,
      // FOR TEST PURPOSE ONLY
      //badUser: false,
      // FOR TEST PURPOSE ONLY (end)
      loginUrl:
        process.env.VUE_APP_API_BASE_URL + '/user-management/login' + '?serviceurl=' + process.env.VUE_APP_ENTRY_URL,
      registerUrl: process.env.VUE_APP_ENTRY_URL.includes('preportal2')
        ? process.env.VUE_APP_ENTRY_URL.replace('/preportal2', '') + '/register'
        : process.env.VUE_APP_ENTRY_URL.replace('/portal', '') + '/register',
      quota: {},
      showBanner: true,
      bannerText: '',
      // if there is data from wordpress, it is injected to window. Otherwise stand-alone.
      wpData: window.wpData ? window.wpData : {},
      // wpdata, // UNCOMMMENT TO RUN IN WORDPRESS, COMMENT TO RUN SOLO
      // wpData: { // // UNCOMMENT TO RUN SOLO, COMMENT TO RUN IN WordPress
      //   image_path: '/portal/img/' //default value for out of WP, delete if wp fails
      //   // npm run serve: '/img/', for npm run portal: '/portal/img/'
      // }
      // tool to force reload router-view
      forceReload: 0,
      // message modal
      modalTitle: '',
      modalMessage: '',
    }
  },
  // props: {
  //   wpData: window.wpData
  // },
  computed: {
    standAlone() {
      return process.env.VUE_APP_MODE === 'portal'
    },
    devStandAlone() {
      return process.env.VUE_APP_MODE === 'development'
    },
    development() {
      return (
        process.env.VUE_APP_MODE === 'development' ||
        process.env.VUE_APP_MODE === 'stage' ||
        process.env.VUE_APP_MODE === 'devwp'
      )
    },
    logoutUrl() {
      return (
        process.env.VUE_APP_API_BASE_URL + '/user-management/logout' + '?serviceurl=' + process.env.VUE_APP_ENTRY_URL
      )
    },
    userType() {
      if (this.auth) {
        if (this.isAdmin) return 'Admin'
        if (this.isUser) return 'User'
        if (this.isSelf) return 'Self'
        if (this.auth) return 'Auth'
      } else {
        return 'none'
      }
    },
    // FOR TEST PURPOSE ONLY
    // testLoggedIn: {
    //   get: function () {
    //     return this.auth ? true : false
    //   },
    //   set: function (value) {
    //     if (value) {
    //       const token = this.badUser ? 'untokenmuymalo' : 'gssc_superuser'
    //       const user = this.badUser ? 'badToken' : 'testUser'
    //       this.$store.dispatch('saveLogin', {
    //         token: token,
    //         user: user,
    //         roles: ['GSSC - Users', 'GSSC - Administrators', 'GSSC - SelfRegistration'],
    //       })
    //     } else {
    //       this.onLogout()
    //     }
    //   },
    // },
    // noHeaders: {
    //   get: function () {
    //     return this.$store.state.user === "NO_HEADERS";
    //   },
    //   set: function (value) {
    //     if (value) {
    //       const token = 'gssc_superuser'
    //       const user = 'NO_HEADERS'
    //       this.$store.dispatch('saveLogin', {
    //         token: token,
    //         user: user,
    //         roles: ['GSSC - Users', 'GSSC - Administrators', 'GSSC - SelfRegistration']
    //       })
    //     } else {
    //       this.onLogout()
    //     }
    //   }

    // },
    //////FOR TEST  END /////////
    navLinksLeft() {
      return [
        { show: true, path: '/', name: 'Explorer', cl: 'app-main__assets' },
        {
          show: true,
          path: '/datasets',
          name: 'Datasets',
          cl: 'app-main__datasets',
        },
      ]
    },
    navLinksRight() {
      return [
        {
          show: this.auth && this.isUser,
          path: '/filters',
          name: 'Filters',
          cl: 'app-main__filters',
        },
        {
          show: this.auth && this.isUser,
          path: '/files',
          name: 'Workspace',
          cl: 'app-main__files',
        },
      ]
    },
    auth() {
      return this.$store.getters.isAuthenticated
    },
    isSelf() {
      return this.$store.getters.isSelf
    },
    isUser() {
      return this.$store.getters.isUser
    },
    isAdmin() {
      return this.$store.getters.isAdministrator
    },
    user() {
      return this.$store.getters.user
    },
    clsDisplayBanner() {
      return this.showBanner ? '' : 'd-none'
    },
  },
  beforeCreate() {
    console.log('Version built on: ', document.documentElement.dataset.buildTimestampUtc)
    console.log('VUE_APP_MODE: ', process.env.VUE_APP_MODE)
  },
  async created() {
    /* STAND-ALONE */
    if (this.standAlone) {
      this.wpData = {
        site_url: 'https://gssc.esa.int',
        image_path: '/portal/img/',
      }
    }
    if (this.devStandAlone) {
      this.wpData = {
        site_url: 'https://gssc.esa.int',
        image_path: '/img/',
      }
    }
    this.$store.dispatch('tryAutoLogin')
    // FOR TEST PURPOSE ONLY
    // if (this.$store.state.token === 'untokenmuymalo') this.badUser = true
    ///////////////////////
    console.log('THIS LOGIN URL ', this.loginUrl)
    if (this.$route.query.ticket) {
      console.log('RUNNING APILOGIN')
      await this.apiLogin()
      this.showRouterView = true
    } else {
      this.showRouterView = true
    }

    const redirectTo = this.$route.query.redirect
    const datalabTo = this.$route.query.datalab

    //////////// REDIRECT FUNCTIONALITY //////////////////////
    // Redirect if "redirect" param exists in route
    if (redirectTo) {
      console.log('REDIRECTING TO', redirectTo)
      if (redirectTo === 'datalabs' && datalabTo) {
        // REDIRECT & LAUNCH SPECIFIC DATALAB
        // If route is not valid, this returns the root path and gives a warning
        if (this.$router.resolve({ name: redirectTo }).href !== '/portal/') {
          this.$router.push({
            name: redirectTo,
            params: { datalabTo },
          })
        }
      } else {
        // OTHER REDIRECTS
        // If route is not valid, this returns the root path and gives a warning
        if (this.$router.resolve({ name: redirectTo }).href !== '/portal/') {
          this.$router.push({
            name: redirectTo,
          })
        }
      }
    }
    // FOR DEBUGGING FORCE REDIRECT
    // this.$router.push({
    //   name: 'admin',
    // })
    //////////
  },
  async mounted() {
    const redirectTo = this.$route.query.redirect

    // ["GSSC - Users","GSSC - Administrators"]
    //////////// REDIRECT FUNCTIONALITY //////////////////////
    // Redirect if "redirect" param exists in route
    if (redirectTo) {
      console.log('REDIRECTING TO', redirectTo)
      // If route is not valid, this returns the root path and gives a warning
      if (this.$router.resolve({ name: redirectTo }).href !== '/portal/') {
        this.$router.push({
          name: redirectTo,
        })
      }
    }
    // FOR DEBUGGING FORCE REDIRECT
    // this.$router.push({
    //   name: 'admin',
    // })
    //////////
    if (this.auth && this.isUser) {
      this.updateRunningLabs()
    }
    if (this.showBanner) {
      const response = await api.getBanners()
      if (response) {
        const banner = response.results.find((banner) => banner.active == 'true')
        console.log('banner', { banner })
        if (banner) {
          this.bannerText = banner.text
        } else {
          this.showBanner = false
        }
      } else {
        this.showBanner = false
      }
    }
    // Handler of BE notified errors
    this.$root.$on('be-error', this.doThis)
  },
  methods: {
    // method to force reload routerview
    forceReloadView() {
      console.log('LOGOUT OR LOGIN FORCE RELOADING')
      if (this.auth) {
        this.forceReload += 1
      }
      // redirect to assets, '/', when not logged in and we are in a route that requiresAuth
      if (!this.auth && this.$route.meta.requiresAuth) {
        this.redirectToAssets()
      }
    },
    redirectToAssets() {
      this.$router.push({
        name: 'assets',
      })
    },
    doThis() {
      console.log('ERROR ROOT FROM BACKEND')
    },
    async onLogout() {
      console.log('ON LOGOUT')
      const response = await api.logout()
      console.log(response)
      this.onLogoutClearStore()
      // window.location.href = this.logoutUrl
    },
    onLogoutClearStore() {
      this.$store.dispatch('logout')
      this.forceReloadView()
    },
    activeRoute(path) {
      // console.log(path, this.$route.path)
      if (path === '/lab/') return this.$route.path.includes(path)
      else return this.$route.path === path
    },
    async updateRunningLabs() {
      if (this.auth && this.isUser) {
        const response = await api.getSavedLabs()
        if (response.results) {
          this.labLinks = response.results.map(function(row) {
            // console.log({ row })
            return {
              id: row.id,
              show: true, //row.status === 'Running',
              name: row.name,
              url: row.url,
              path: '/lab',
              last_access_time: row.last_access_time,
              status: row.status,
            }
          })
          this.labLinks.sort((a, b) =>
            a.last_access_time > b.last_access_time ? -1 : b.last_access_time > a.last_access_time ? 1 : 0
          )
          this.someLabRunning =
            this.labLinks && this.labLinks.length > 0 && this.labLinks.filter((lab) => lab.show == true).length > 0
        } else {
          this.labLinks = []
        }
      }
    },
    async apiLogin() {
      if (this.$route.query.ticket) {
        const ticket = this.$route.query.ticket
        const response = await api.login(ticket)
        if (typeof response === 'object') {
          if ('jwt' in response) {
            this.$store.dispatch('saveLogin', {
              token: response.jwt,
              user: response.username,
              roles: response.roles,
            })
            // Force reload view to reload assets so that:
            // will show the right assets available to logged in users
            // will show correct stations available to logged in users
            // this.forceReloadView()
          }
        } else {
          // REDIRECTION WAS LOOPING IF USER WAS ON COSMOS BUT NOT ON API
          // console.log('response is not an object with jwt')
          // window.location.href =
          //   process.env.VUE_APP_API_BASE_URL +
          //   "/user-management/login" +
          //   "?serviceurl=" +
          //   process.env.VUE_APP_ENTRY_URL
        }
        // const parseableResponse = response.replace(/'/gi, '"')
        // if (helpers.isJsonString(parseableResponse)) {
        //   const jsonresp = JSON.parse(parseableResponse)
        //   if ('jwt' in jsonresp) {
        //     console.log("RESPONSE IN APP.VUE", jsonresp.jwt)
        //   }
        // } else {
        //   window.location.href = process.env.VUE_APP_API_BASE_URL
        //     + "/user-management/login?ticket=" + this.$route.query.ticket;
        // }
      }
      return 'done'
    },
    openAboutModal() {
      $('.app-main__about-modal').modal()
    },
    openLoginModal() {
      $('.app-main__login-modal').modal()
    },
    async loginRequested(username, password) {
      let error = null
      const response = await api.signin(username, password)
      if (typeof response === 'object') {
        if ('jwt' in response) {
          this.$store.dispatch('saveLogin', {
            token: response.jwt,
            user: response.username,
            roles: response.roles,
          })
        } else {
          // object response, no jwt => wrong user
          error = 'Wrong Username or Password'
        }
      } else {
        error = response
      }
      if (error) {
        this.modalTitle = 'Sign in error'
        this.modalMessage = error
        Vue.nextTick(() => {
          $('.app-main__message-modal').modal()
          error = ''
        })
      }
    },
    openProfileModalIfNotMobile() {
      if (window.innerWidth >= 991) {
        this.openProfileModal()
      }
    },
    async openProfileModal() {
      $('.app-main__profile-modal').modal()
      const response = await api.getQuota()
      // console.log(response)
      this.quota = {
        quotaUsed: response.used_space,
        quotaMax: response.max_space,
      }
    },
    toggleBanner() {
      this.showBanner = !this.showBanner
    },
    profileClosed() {
      console.log('profileclosed')
      this.quota = {}
    },
    // FOR TEST PURPOSE ONLY
    // switchUser() {
    //   this.badUser = !this.badUser
    //   this.testLoggedIn = true
    // },
    ///////////////////////
    launchLogin() {
      window.location.href = this.loginUrl
    },
  },
  watch: {
    $route() {
      console.log('routeMeta', this.$route.meta)

      if (this.$route.name != 'register' && this.$route.name != 'help') {
        this.showLoader = true
      }

      //On mobile remove overlay menu when item is tapped
      if (window.innerWidth < 991) {
        // console.log('on route change');
        const body = document.body
        const menuButton = document.getElementById('esa-menu')
        let menu = document.querySelector('#portal-nav > .collapse')
        let menuCollapsed = menuButton.className.includes('collapsed')
        if (!menuCollapsed) {
          // console.log('not menu collapsed');
          menuButton.classList.toggle('collapsed')
          menu.setAttribute('aria-hidden', false)
          menu.classList.toggle('fade-out')
          menu.classList.toggle('show')
          body.classList.remove('noscroll')
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/theme';

.portal-header {
  &__banner {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 0;

    a {
      color: white;
      text-decoration: underline;
    }
  }
}

.alert-primary {
  background: $pure-teal;
  color: white;
  border: unset;
  margin: 0;
}

.banner-text {
  flex-grow: 1;
}

.close-banner {
}
.nav-link.my-disabled {
  opacity: 0.6;
  &:active {
    pointer-events: none;
  }
}
</style>
